import { render, staticRenderFns } from "./zhuanyeku_mobile.vue?vue&type=template&id=488aab76&scoped=true"
import script from "./zhuanyeku_mobile.vue?vue&type=script&lang=js"
export * from "./zhuanyeku_mobile.vue?vue&type=script&lang=js"
import style0 from "./zhuanyeku_mobile.vue?vue&type=style&index=0&id=488aab76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488aab76",
  null
  
)

export default component.exports